export const iconFontAwesomeMedicalHealthHandHoldingMedical = (
	<i className="fa-solid fa-hand-holding-medical"></i>
);
